export const MagicSelectionLines = {
    pickSix: [
        '1 Line',
        '32 Lines',
        '108 Lines',
        '256 Lines',
        '500 Lines'
    ],
    placeAccumulator: [
        '1 Line',
        '16 Lines',
        '64 Lines',
        '144 Lines',
        '288 Lines',
    ],
    jackpot: [
        '1 Line',
        '8 Lines',
        '54 Lines',
        '96 Lines',
        '200 Lines',
    ]
};